/**
 * AddSectionButton — Prominent button at the bottom of the section list.
 *
 * Opens the widget library panel when clicked.
 */

import { Plus } from 'lucide-react'

interface AddSectionButtonProps {
  onClick: () => void
}

export function AddSectionButton({ onClick }: AddSectionButtonProps) {
  return (
    <button
      onClick={onClick}
      className="mt-2 flex w-full items-center justify-center gap-1.5 rounded-sm border-2 border-dashed border-gray-200 py-2.5 text-sm font-medium text-gray-400 transition-colors hover:border-sky-300 hover:text-sky-500"
    >
      <Plus className="h-4 w-4" />
      Add Section
    </button>
  )
}
